import { WorkflowApproverResponse } from '~/api/approvers'
import fetch from '~/common/fetch'

const approversForWOOffer = (workOrderId: number, formData: FormData): Promise<WorkflowApproverResponse> =>
  fetch.post(`/api/v2/work-orders/${workOrderId}/offer/approvers`, formData)

export const offerReleaseApi = {
  approversForWOOffer
}
